"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/segments/RoomSidebar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// Desktop's sidebar
var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');

var _RoomSidebar = require('web/components/VideoCall/RoomSidebar'); var _RoomSidebar2 = _interopRequireDefault(_RoomSidebar);





const RoomSidebarContainer = ({ onRoomLinkCopy }) => {
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)

  return (
    _react2.default.createElement(_RoomSidebar2.default, {
      roomName: roomName,
      roomLink: roomLink,
      onRoomLinkCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    )
  )
}

// connect() memoised the container on its props; memo keeps that boundary.
exports. default = _react.memo.call(void 0, RoomSidebarContainer)
